(function() {
  angular
    .module('cfn')
    .factory('seedPlanningDataResolver', seedPlanningDataResolver);

  seedPlanningDataResolver.$inject = ['$q', 'seedPlanningModel'];

  /**
   * Resolve function
   */
  function seedPlanningDataResolver($q, seedPlanningModel) {
    return function() {
      var initService = seedPlanningModel.init();
      var loadYears = seedPlanningModel.loadAvailableYears();
      var combinedPromise;

      app.farmnetControllers.data = {};

      app.showLoader();

      loadYears.then(function(response) {
        var year = new Date().getFullYear();
        let minYear = year - 2;
        let maxYear = year + 5;
        if (response.data && response.data.length > 0) {
          minYear = Math.min(response.data[0], minYear);
          maxYear = Math.max(response.data[response.data.length - 1], maxYear);
        }

        const allowedYears = [];
        for (let i = minYear; i <= maxYear; i++) {
          allowedYears.push(i);
        }

        app.farmnetControllers.data.allowedYears = allowedYears;
      });

      combinedPromise = $q.all([initService, loadYears]);

      combinedPromise.then(function() {
        app.hideLoader();
      });

      return combinedPromise;
    };
  }
})();
